import React from 'react';
import Icon from 'components/ui/element/Icon';

const NotAuthorizedTemplate = ({formatMessage}) => (
    <div className="no-authorized-template">
        <h1>{formatMessage({id: 'title.serviceNotFound.service'}, {service: 'Pnet'})}</h1>
        <p>{formatMessage({id: 'notAuthorized.monitoring.description'})}</p>
        <ul>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option1'})}</li>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option2'})}</li>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option3'})}</li>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option4'})}</li>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option5'})}</li>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option6'})}</li>
            <li>{formatMessage({id: 'notAuthorized.monitoring.option7'})}</li>
        </ul>
        <div className="no-authorized-template__contact">
            <h1><Icon key={'envelope'} name={'envelope'} /> {formatMessage({id: 'label.contacts.contact'})}</h1>
            <p>{formatMessage({id: 'notAuthorized.contact'})}</p>
            <ul>
                <li><a href="mailto:Solutions.EMS.Spain@eu.equinix.com">Solutions.EMS.Spain@eu.equinix.com</a></li>
            </ul>
        </div>
    </div>
);

module.exports = NotAuthorizedTemplate;



// WEBPACK FOOTER //
// ./src/routes/no-authorized-templates/pnet.js